'use client'

import React from 'react'
import { CheckCircle } from 'solar-icons'

import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  LoadingDots,
} from '@/components/ui'
import { KotFulFillItem } from '@/components/forms'

interface KotFulfillModalProps extends React.ComponentPropsWithoutRef<'div'> {
  item?: any
  cartId?: string
}

export const KotFulfillModal = ({ item, cartId }: KotFulfillModalProps) => {
  const [open, setOpen] = React.useState(false)
  const [updateState, setUpdateState] = React.useState()

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="w-full" disabled={updateState}>
          {updateState && <LoadingDots dotClassName="size-1.5" />}
          {!updateState && (
            <>
              <CheckCircle strokeWidth={1.2} className="size-5 text-gray-950" />
              <span>Mark as Fulfilled</span>
            </>
          )}
        </Button>
      </DialogTrigger>
      <DialogContent closeOnOverlay size="lg">
        <DialogHeader>
          <DialogTitle>{item?.product_name}</DialogTitle>
        </DialogHeader>

        {open && (
          <KotFulFillItem
            item={item}
            cartId={cartId}
            onSuccess={() => {
              setOpen(false)
            }}
            setUpdateState={setUpdateState}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
